import logo from "../assets/wonderstood-high-resolution-logo-grayscale-transparent.png";

interface NavigationItem {
    name: string;
    href: string;
}

const legalLinks: NavigationItem[] = [
    { name: 'Terms of Service', href: '/terms' },
    { name: 'Privacy Policy', href: '/privacy' },
];
  
export default function Footer() {
    return (
      <footer className="bg-[#0d0d0e] border-t border-white/5">
        <div className="mx-auto max-w-7xl px-6 py-10 sm:py-12 lg:px-8">
          <div className="md:flex md:items-center md:justify-between">
            {/* Logo and tagline */}
            <div className="space-y-3 md:max-w-md">
              <img
                alt="wonderstood"
                src={logo}
                className="h-9 brightness-0 invert"
              />
              <p className="text-sm text-gray-400">
                Connecting professionals with those seeking expert guidance for career growth and success.
              </p>
            </div>

            {/* Links */}
            <div className="mt-8 md:mt-0">
              <ul className="flex flex-wrap gap-x-6 gap-y-2">
                {legalLinks.map((item) => (
                  <li key={item.name}>
                    <a href={item.href} className="text-sm text-gray-400 hover:text-purple-400 transition-colors">
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Copyright */}
          <div className="mt-8 border-t border-white/5 pt-8">
            <p className="text-sm text-gray-500 text-center md:text-left">
              &copy; 2025 wonderstood, LLC. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    )
  }
  